// Staff-set spacing: "40px", "4%", "2rem" or a plain number (px). Minus values pull things closer.
const UNIT = /^-?\d*\.?\d+(px|%|rem|em|vh|vw)$/i;

export const space = (value) => {
    if (value === undefined || value === null || value === "") return undefined;
    const raw = String(value).trim();
    if (!raw) return undefined;
    if (/^-?\d*\.?\d+$/.test(raw)) return `${raw}px`;
    return UNIT.test(raw) ? raw : undefined;
};

/** Margin style for a section, header or footer from its space_top / space_bottom settings. */
export const spacingStyle = (props = {}, topKey = "space_top", bottomKey = "space_bottom") => {
    const style = {};
    const top = space(props[topKey]);
    const bottom = space(props[bottomKey]);
    if (top) style.marginTop = top;
    if (bottom) style.marginBottom = bottom;
    return style;
};

export default spacingStyle;
